import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { MaybeNull } from 'src/app/utils';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { ConnectionRequest } from '../../relation-request.interface';
import { userConnectionRowData } from '../connection-table-factory';

export class ConnectionListTable {
  public buildTableData(items: ConnectionRequest[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DATE];
  }

  private getManageCellAttribute(): MaybeNull<TableCellAttribute> {
    return null;
  }

  private getTableBody(items: ConnectionRequest[]): GridTableBody[] {
    return items.map(userConnectionRowData);
  }
}
